/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <GlobalGraph class="graph" v-if="series.length" :series="computedSeries" :xAxisData="xAxis" :loading="loading" :theme="theme" :isOnClickValueRequired="true" />
</template>

<script>
import {
  mapGettersMixin
} from '@/util/mixin/index'
import GlobalGraph from '@/components/common/GlobalGraph.vue'
import Inverter from '@/services/Inverter'
import {
  mapGetters,
  mapMutations
} from 'vuex'
const moment = require('moment')

export default {
  props: ['date', 'type', 'blockId', 'invRoom', 'graph'],
  mixins: [mapGettersMixin],
  components: {
    GlobalGraph
  },
  data() {
    return {
      loading: false,
      series: [],
      xAxis: [],
      interval: null
    }
  },
  created() {
    this.setIntervalWithoutDelay(this.callAllApi)
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getActivePlantInfo']),
    enableComputedWatch() {
      return `${this.blockId} ${this.invRoom} ${this.date[0]} ${this.date[1]} ${this.getSelectedPlantId} ${this.type}`
    },
    computedSeries() {
      const cloneSeries = _.cloneDeep(this.series)
      return cloneSeries.map(el => {
        el.name = this.$t(el.name)
        return el
      })
    }
  },
  methods: {
    ...mapMutations([
      'SET_LAST_CALL_TIME',
      'SET_PROGRESS_BAR'
    ]),
    async callAllApi() {
      let updateTime = moment().format('MM-DD-YYYY H:mm:ss')
      this.SET_LAST_CALL_TIME(updateTime)
      await this.generationData()
    },
    async generationData() {
      try {
        this.SET_PROGRESS_BAR(true)
        this.series = []

        let param = {
          plantId: this.getSelectedPlantId,
          blockId: this.blockId,
          startDate: moment(this.date[0]).format('YYYY-MM-DD'),
          endDate: moment(this.date[1]).format('YYYY-MM-DD'),
          type: this.type
        }

        if (this.invRoom && (this.invRoom !== null || this.invRoom !== undefined)) {
          param['inverterRoom'] = this.invRoom
        }

        const response = await Inverter.inverterPower(param)
        this.SET_PROGRESS_BAR(false)

        this.series.push({
          name: 'Irradiance',
          type: 'line',
          markPoint: {
            data: [{
              type: 'max',
              name: 'Max'
            }, {
              type: 'min',
              name: 'Min'
            }]
          },
          markLine: {
            data: [{
              type: 'average',
              name: 'Avg'
            }]
          },
          data: response.data.message.irradianceData
        })
        if (this.getActivePlantInfo('module_brand') === 'SSP') {
          this.series.push({
            name: 'Solar Set Point',
            type: 'line',
            markPoint: {
              data: [{
                type: 'max',
                name: 'Max'
              }, {
                type: 'min',
                name: 'Min'
              }]
            },
            markLine: {
              data: [{
                type: 'average',
                name: 'Avg'
              }]
            },
            data: response.data.message.sspData
          })
        }
        if (this.type.toLowerCase() === 'total') {
          this.series.push({
            name: 'Power',
            type: 'line',
            markPoint: {
              data: [{
                type: 'max',
                name: 'Max'
              }, {
                type: 'min',
                name: 'Min'
              }]
            },
            markLine: {
              data: [{
                type: 'average',
                name: 'Avg'
              }]
            },
            data: response.data.message.powerData
          })
        } else {
          Object.keys(response.data.message.powerData).forEach(inverterId => {
            this.series.push({
              name: inverterId,
              type: 'line',
              markPoint: {
                data: [{
                  type: 'max',
                  name: 'Max'
                },
                {
                  type: 'min',
                  name: 'Min'
                }
                ]
              },
              markLine: {
                data: [{
                  type: 'average',
                  name: 'Avg'
                }]
              },
              data: response.data.message.powerData[inverterId]
            })
          })
        }
        this.xAxis = response.data.message.axis
      } catch (err) {
        this.SET_PROGRESS_BAR(false)
      }
    }
  },
  watch: {
    enableComputedWatch() {
      this.setIntervalWithoutDelay(this.callAllApi)
    },
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi)
      }
    }
  }
}
</script>

<style scoped>
  .graph {
    width: 100%;
    height: 400px;
  }
</style>
